import { AbstractControl } from '@angular/forms';

/**
 * Input Type Definition Handler
 */
export class InputType {
  /** Ensures the input group can define the ID directly **/
  public setId!: (id: string) => void;
  /** Provides the option to get the ID from the component **/
  public getId?: () => string;
  /** Enables the option to set attributes on the component **/
  public setAttribute?: (attr: string, value: string) => void;
  /** Provides the option to get the attribute from handles components **/
  public getAttribute?: (attr: string) => string;
  /** Enables the input group to fetch the FormControl **/
  public getFormControl!: () => AbstractControl;
  /** Sets internal label for the input **/
  public setInternalLabel?: (label: string) => void;
}
